import React from "react";
import { Grid, Typography } from "@mui/material";
import { AccessTime as AccessTimeIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import * as Styled from "./styles";

type OrdersDeliveredTimeProps = {
  data: {
    porcentage: number;
    estimatedAverageTime: number;
    averageTimePerformed: number;
  };
};

const OrdersDeliveredTime = ({
  data: { porcentage, estimatedAverageTime, averageTimePerformed },
}: OrdersDeliveredTimeProps) => {
  const { t } = useTranslation();
  return (
    <>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
        {t("orderDeliveredTime")}
      </Typography>
      <Grid container columns={12}>
        <Grid item display="flex" alignItems="center">
          <Styled.ContentPercentage>
            <Typography variant="h4" component="div" marginLeft={1}>
              {(Math.round(porcentage) / 100).toLocaleString("pt-BR", {
                style: "percent",
              })}
            </Typography>
          </Styled.ContentPercentage>
        </Grid>
        <Grid item display="flex" alignItems="center">
          <Styled.ContentTimeOrders>
            <AccessTimeIcon style={{ marginRight: 5 }} />
            <div>
              <Typography
                color="text.secondary"
                display="flex"
                flexDirection="row"
              >
                {t("estimatedAverageTime")}{" "}
                <Typography color="#000" fontWeight="bold" marginLeft={0.5}>
                  {Math.round(estimatedAverageTime)} min
                </Typography>
              </Typography>
              <Typography
                color="text.secondary"
                display="flex"
                flexDirection="row"
              >
                {t("averageTimePerformed")}{" "}
                <Typography
                  color="#2E7D32"
                  display="flex"
                  flexDirection="row"
                  marginLeft={0.5}
                  alignItems="center"
                >
                  {Math.round(averageTimePerformed)} min
                </Typography>
              </Typography>
            </div>
          </Styled.ContentTimeOrders>
        </Grid>
      </Grid>
    </>
  );
};

export default OrdersDeliveredTime;
